import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SurchargeTypes } from '../../models';
import { HttpClient } from '@angular/common/http';
import { API } from '../config/api';
import { PaginationResponse } from '../config/common';
import { requestQuery } from '../../../@shared/untils';
import { PaginationSurchargeTypeRequest } from '../surcharge-types';

@Injectable()
export class SurchargeTypeService {
    constructor(
        private _http: HttpClient,
        ) {}
    public getSurchargeTypes(request: PaginationSurchargeTypeRequest): Observable<PaginationResponse<SurchargeTypes>> {
        return this._http.get<PaginationResponse<SurchargeTypes>>(`${API.SURCHARGE_TYPE.GET_SURCHARGE_TYPES}?${requestQuery(request)}`);
    }
}